import { t, useLocale } from "@/shared/i18n/locale";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "@/features/auth/use-auth";

export function RequireAuth({ children }: { children: ReactNode }) {
  useLocale();
  const location = useLocation();
  const session = useSession();

  if (session.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-[var(--muted-foreground)]">
        {t("Carregando sessao...")}</div>
    );
  }

  if (session.isError || !session.data || session.data.role !== "ADMIN") {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
